var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.2002,
    r: 13.5,
    stroke: "#D4D4D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5016 11.4324H14.6681V12.5116C14.9801 11.8909 15.7805 11.3333 16.9827 11.3333C19.2875 11.3333 19.8346 12.5688 19.8346 14.8356V19.0339H17.5013V15.3519C17.5013 14.0609 17.1892 13.3329 16.3947 13.3329C15.2928 13.3329 14.8349 14.1175 14.8349 15.3513V19.0339H12.5016V11.4324ZM8.50047 18.9347H10.8338V11.3333H8.50047V18.9347ZM11.1681 8.85469C11.1681 9.05026 11.1294 9.24391 11.0539 9.42436C10.9785 9.60482 10.868 9.76849 10.7288 9.90585C10.4467 10.1862 10.0649 10.3432 9.66714 10.3422C9.27011 10.3419 8.88915 10.1854 8.60664 9.90644C8.46793 9.7686 8.35778 9.60475 8.2825 9.42427C8.20723 9.24379 8.16831 9.05024 8.16797 8.85469C8.16797 8.45977 8.32547 8.08177 8.60722 7.80294C8.88949 7.52361 9.27061 7.36701 9.66772 7.36719C10.0656 7.36719 10.4471 7.5241 10.7288 7.80294C11.01 8.08177 11.1681 8.45977 11.1681 8.85469Z",
    fill: "#2567B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.89bc85d5f3efb045d70ee505b670daca.svg";
export { ForwardRef as ReactComponent };